import { Component, OnInit, AfterViewInit, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { RepresentanteService } from './representantes.service';
import { representanteTranslations, RepresentanteTranslations } from './translations-representantes';
import { getCurrentLanguage } from '../core/helpers/utils';
import { NotificationsService } from '../core/service/notifications.service';

// services
import { EventService } from 'src/app/core/service/event.service';

// constants
import { EventType } from 'src/app/core/constants/events';

// types
import { SortEvent } from 'src/app/shared/advanced-table/sortable.directive';
import { Column } from 'src/app/shared/advanced-table/advanced-table.component';
import { Representante } from './representantes.model';

@Component({
  selector: 'app-list-representantes',
  templateUrl: './list-representantes.component.html',
  styleUrls: ['./list-representantes.component.scss']
})
export class ListRepresentantesComponent implements OnInit {

  constructor(
    private eventService: EventService,
    private router: Router,
    private elRef: ElementRef,
    private representantesService: RepresentanteService,
    private notificationService: NotificationsService) { }

  records: Representante[] = [];
  columns: Column[] = [];
  pageSizeOptions: number[] = [10, 25, 50, 100];

  // Botón de acción de la tabla
  currentLanguage: string = getCurrentLanguage()
  buttonTitle: string = '';
  buttonLink: string = 'representantes/new';

  // Control de loading de la tabla cuando los usuarios hayan sido recibidos desde el backend
  loaded: boolean = false;

  // Control de errores
  error: string = '';

  // Animación de loading
  loading: boolean = false;

  // Para controlar las búsquedas
  allDatasearch: Representante[] = []

  showConfirmDeleteModal: boolean = false;
  representanteToDelete: Representante | null = null;
  showConfirmEstadoModal: boolean = false;
  representanteToEstado: Representante | null = null;
  estadoAction: 'ACTIVAR' | 'DESACTIVAR' | null = null;

  ngAfterViewInit(): void {

  }
 

  ngOnInit(): void {
    //Le doy valor al botón
    const currentTranslations = representanteTranslations[this.currentLanguage].TABLE;
    this.buttonTitle = currentTranslations.BUTTON;

    this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
      {
        title: currentTranslations.REPRESENTANTES,
        breadCrumbItems: [{ label: currentTranslations.REPRESENTANTES, path: '.', active: true }]
      }
    );
    this._fetchData();

  }

  /**
 * fetches table records
 */
  _fetchData(): void {
    this.representantesService.getRepresentantes("es_representante=true").subscribe((res) => {
      this.records = res;
      //console.log("records",this.records)
      this.allDatasearch = this.records; // Guardo una copia de todos los datos para la búsqueda
      this.initTableCofig();
      this.loaded = true;
    },
      (error: string) => {
        this.error = error;
        this.loaded = false;
      });
  }

  /**
   * initialize advanced table columns
   */
  initTableCofig(): void {
    let currentLanguage: string = getCurrentLanguage()
    const currentTranslations = representanteTranslations[currentLanguage].TABLE;
    this.columns = [
      {
        name: 'nombre',
        label: currentTranslations.NAME,
        formatter: (record: Representante) => record.nombre,
        width: 245,
      },
      {
        name: 'apellidos',
        label: currentTranslations.LAST_NAME,
        formatter: (record: Representante) => record.apellidos,
        width: 400,
      },
      {
        name: 'validado',
        label: currentTranslations.VALIDADO,
        formatter: (record: Representante) => record.validado,
        width: 30,
      },
      {
        name: 'activo',
        label: currentTranslations.ACTIVO,
        formatter: (record: Representante) => record.activo,
        width: 30,
      },
      {
        name: 'accionesRepresentantes',
        label: currentTranslations.ACTIONS,
        formatter: (record: Representante) => null, // No es necesario enviar nada a advanced table porque la columna acciones está personalizada en el componente
        width: 360,
        sort: false
      }
    ];
  }

  // compares two cell values
  compare(v1: string | number, v2: string | number): any {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  /**
   * Sort the table data
   * @param event column name, sort direction
   */
  onSort(event: SortEvent): void {
    if (event.direction === '') {
      this.records = this.allDatasearch;
    } else {
      this.records = [...this.records].sort((a, b) => {
        const res = this.compare(a[event.column] as string | number, b[event.column] as string | number);
        return event.direction === 'asc' ? res : -res;
      });
    }
  }

  /**
* Recibe un texto y lo normaliza a lowercase y quita tildes para poder hacer búsquuedas
* @param text Texto a normalizar
*/
  normalizeText(text: string): string {
    return text.trim().toLocaleLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Normaliza letras con tilde
  }


  /**
 * Match table data with search input
 * @param row Table row
 * @param term Search the value
 */
  matches(row: Representante, term: string) {
    return this.normalizeText(row.nombre as string).includes(this.normalizeText(term))
      || this.normalizeText(row.apellidos as string).includes(this.normalizeText(term))
  }

  /**
     * Search Method
    */
  searchData(searchTerm: string): void {
    if (searchTerm === '') {
      this.records = this.allDatasearch;
    }
    else {
      let updatedData = this.allDatasearch;

      //  filter
      updatedData = updatedData.filter(record => this.matches(record, searchTerm));
      //console.log("updatedData ->",updatedData)
      this.records = updatedData;
    }

  }

  openDeleteModal(parte: Representante) {
    this.representanteToDelete = parte;
    this.showConfirmDeleteModal = true;
  }

  closeDeleteModal() {
    this.showConfirmDeleteModal = false;
    this.representanteToDelete = null;
  }

  confirmDelete() {
    if (this.representanteToDelete?.id) {
      this.representantesService.deleteRepresentante(this.representanteToDelete.id).subscribe(() => {
        const deleteRepresentanteListSuccessMessage: string = $localize`:@@deleteRepresentanteListSuccessMessage:Representante borrado correctamente`;
        this.notificationService.showSuccessNotification(deleteRepresentanteListSuccessMessage);
        this._fetchData(); // Actualiza los datos después de borrar
        this.closeDeleteModal();
      });
    }
  }

  openEstadoModal(representante: Representante) {
    this.representanteToEstado = representante;
    this.estadoAction = representante.activo === true ? 'DESACTIVAR' : 'ACTIVAR';
    this.showConfirmEstadoModal = true;
  }

  closeEstadoModal() {
    this.showConfirmEstadoModal = false;
    this.representanteToEstado = null;
    this.estadoAction = null;
  }

  confirmEstado() {
    if (this.representanteToEstado?.id && this.estadoAction) {
      this.representantesService.updateRepresentanteEstado(this.representanteToEstado.id, this.estadoAction).subscribe(() => {
        const shouldBeActive = this.estadoAction === 'ACTIVAR';
        this.records = this.records.map((record) =>
          record.id === this.representanteToEstado?.id ? { ...record, activo: shouldBeActive } : record
        );
        this.allDatasearch = this.allDatasearch.map((record) =>
          record.id === this.representanteToEstado?.id ? { ...record, activo: shouldBeActive } : record
        );
        const estadoSuccessMessage: string = this.estadoAction === 'ACTIVAR'
          ? $localize`:@@activarUsuarioSuccessMessage:Usuario activado correctamente`
          : $localize`:@@desactivarUsuarioSuccessMessage:Usuario desactivado correctamente`;
        this.notificationService.showSuccessNotification(estadoSuccessMessage);
        this.closeEstadoModal();
      });
    }
  }


}
